import { get, post } from "Service";

/**
 * Fetches all contract drafts for the current user.
 */
const getDrafts = () => {
    const request = {
        subUrl: "ContractAI/drafts",
        data: {},
        isAuth: false, // Assuming auth is required for user drafts
    };
    return get(request);
};

/**
 * Saves or updates a contract draft.
 */
const saveDraft = (payload: any) => {
    const request = {
        subUrl: "ContractAI/drafts",
        data: payload,
        isAuth: false,
    };
    return post(request);
};

/**
 * Generates a contract draft using AI (Gemini).
 */
const generateAIContract = (payload: any) => {
    const request = {
        subUrl: "ContractAI/generate",
        data: payload,
        isAuth: false,
    };
    return post(request);
};

/**
 * Fetches a specific draft by ID.
 */
const getDraftById = (id: string | number) => {
    const request = {
        subUrl: `ContractAI/drafts/${id}`,
        data: {},
        isAuth: false,
    };
    return get(request);
};

/**
 * Downloads the contract as a PDF.
 */
const downloadContractPDF = (payload: { content: string; fileName: string }) => {
    return post({
        subUrl: "ContractAI/download-pdf",
        data: payload,
        isAuth: false,
        excel: true, // blob response type
    });
};

/**
 * Emails the contract PDF to specified parties.
 */
const emailContractToParties = (payload: { content: string; subject: string; emails: string[]; fileName: string }) => {
    return post({
        subUrl: "ContractAI/email-to-parties",
        data: payload,
        isAuth: false,
    });
};

/**
 * Initiates a payment session for a contract stage.
 */
const initiateContractPayment = (payload: { contractId: number; paymentType: string }) => {
    return post({
        subUrl: "ContractAI/initiate-payment",
        data: payload,
        isAuth: false,
    });
};

/**
 * Marks a contract draft as completed.
 */
const completeDraft = (id: number) => {
    return post({
        subUrl: `ContractAI/complete/${id}`,
        data: {},
        isAuth: false,
    });
};

/**
 * Generates a share token for a draft.
 */
const generateShareToken = (id: number) => {
    return post({
        subUrl: `ContractAI/generate-share-token/${id}`,
        data: {},
        isAuth: false,
    });
};

/**
 * Fetches a public draft for read-only viewing.
 */
const getPublicDraft = (token: string) => {
    return get({
        subUrl: `ContractAI/public-view/${token}`,
        isAuth: false,
    });
};

/**
 * Downloads the signed PDF from Digio.
 */
const downloadSignedPDF = (documentId: string) => {
    return get({
        subUrl: `Status/download-signed-document/${documentId}`,
        isAuth: false,
        excel: true, // blob response type
    });
};

const ContractAIApi = {
    getDrafts,
    saveDraft,
    generateAIContract,
    getDraftById,
    downloadContractPDF,
    emailContractToParties,
    initiateContractPayment,
    completeDraft,
    generateShareToken,
    getPublicDraft,
    downloadSignedPDF,
};

export default ContractAIApi;
